
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fullstack",
      function () {
        return require("private-next-pages/fullstack.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fullstack"])
      });
    }
  